import moment from 'moment'
import { useSchedulingFormStep, usePackageFormStep } from './hooks'
import Button from '../button'
import Steps from '../steps'
import { useServiceScheduleContext } from '../../context/serviceScheduleContext'
import { SCHEDULING_STEPS } from '../../utils/schedulingConstants'
import * as S from './styles'

const ONLINE_PAYMENT_DEADLINE = process.env.ONLINE_PAYMENT_DEADLINE
const SCHEDULING_MIN_HOURS = process.env.SCHEDULING_MIN_HOURS

const FormSteps = ({ children, finalStep, context }) => {
  const { state: { professionalData, partnersData, scheduleBody, formList, useTerms, packageUseTerms, scheduleBody: { isServicePackage, isSchedulingFromPackage } } } = useServiceScheduleContext()

  const schedulingHook = useSchedulingFormStep({ finalStep, context })
  const packageHook = usePackageFormStep({ finalStep, context })

  const {
    activeStep,
    numberOfSteps,
    currentStep,
    review,
    isHowToPay,
    finalStep: schedulingFinalStep,
    steps,
    backButtonProps,
    scheduleForMoreOnePetProps,
    nextButtonProps,
    handleClickBackButton,
    handleNextButtonClick,
    handleScheduleForMoreOnePet
  } = isServicePackage ? packageHook : schedulingHook

  const shouldShowSteps = (!schedulingFinalStep && !isHowToPay)
  const isFirstStep = currentStep?.step === SCHEDULING_STEPS.PET_AND_SERVICE
  const shouldShowScheduleMoreButton = schedulingFinalStep && review
  const areTermsAccepted = isSchedulingFromPackage
    ? useTerms && packageUseTerms
    : useTerms

  const shouldShowPaymentOptions = () => {
    if (isSchedulingFromPackage) { return false }
    const isInvalidDateTerms = (date, time) => {
      const startOfDay = moment().startOf('day')
      const currentDate = moment()
      const schedulingDate = moment(date)
      const schedulingTime = moment(time, 'HH:mm')
      const schedulingDateTime = schedulingDate.clone().set({
        hour: schedulingTime.get('hour'),
        minute: schedulingTime.get('minute')
      })

      // Válida se a nova data do agendamento está dentro do tempo limite de captura
      const invalidDateTerm = schedulingDateTime.diff(startOfDay, 'days') > ONLINE_PAYMENT_DEADLINE

      // valida se agendamento esta a pelo menos 1 hora da data/hora atual
      const invalidTimeTerm = schedulingDateTime.diff(currentDate, 'hours') < SCHEDULING_MIN_HOURS

      return invalidDateTerm || invalidTimeTerm
    }

    // Verifica se a loja possui pagamento online ativado
    const partnerEnabledPayment = (partnerId, partnersData) => {
      const selectedPartner = partnersData.find(partner => partnerId === partner.id)
      return selectedPartner?.enabledPayment
    }

    // Verifica se o profissional possui pagamento online ativado
    const professionalEnabledPayment = (professionalId, professionalData) => {
      const selectedProfessional = professionalData.find(professional => professionalId === professional.id)
      return selectedProfessional?.enabledPayment
    }

    const currentInvalidDateTerms = isInvalidDateTerms(scheduleBody.selectDay, scheduleBody.selectTime)

    const currentProfessionalPayment = professionalEnabledPayment(scheduleBody.professional_id, professionalData)

    const currentPartnerPayment = partnerEnabledPayment(scheduleBody.partner_id, partnersData)

    // Valida se é possível pagar online (para o agendamento atual)
    const validateCurrentPayment = () => !currentInvalidDateTerms && currentProfessionalPayment && currentPartnerPayment

    // Valida se é possível pagar online (para os agendamentos anteriores)
    const validateFormListPayment = () => {
      // Caso não possua agendamento, retorna como válido
      if (!formList?.length) {
        return true
      }
      const invalidPayment = formList.some(scheduling => {
        const { body, data } = scheduling
        const invalidDateTerm = isInvalidDateTerms(body.selectDay, body.selectTime)
        const professionalPayment = professionalEnabledPayment(body.professional_id, data.professionalData)
        const partnerPayment = partnerEnabledPayment(body.partner_id, data.partnersData)

        return invalidDateTerm || !professionalPayment || !partnerPayment
      })
      return !invalidPayment
    }
    return validateCurrentPayment() && validateFormListPayment()
  }

  return (
    <>
      {shouldShowSteps && (
        <S.StepsContainer>
          <Steps steps={steps.slice(0, 5)} activeStep={activeStep} numberOfSteps={numberOfSteps} />
        </S.StepsContainer>
      )}

      {children}

      <S.WrapperSchedulingActions finalStep={review} firstStep={isFirstStep}>
        <div>
          <>
            <Button
              {...(shouldShowScheduleMoreButton && !isSchedulingFromPackage ? scheduleForMoreOnePetProps : backButtonProps)}
              fontColor='var(--cobasi-blue-light-9)'
              color='var(--the-white)'
              margin='0'
              onClick={shouldShowScheduleMoreButton && !isSchedulingFromPackage ? handleScheduleForMoreOnePet : handleClickBackButton}
            />
            <Button
              {...((!finalStep || !review)) ? nextButtonProps : {
                label: shouldShowPaymentOptions() ? 'Ir para pagamento' : 'Confirmar agendamento',
                disabled: !areTermsAccepted || context.isLoading
              }}
              color='var(--cobasi-blue-light-9)'
              fontColor='var(--the-white)'
              margin='0'
              iconRight
              onClick={handleNextButtonClick}
            />
          </>
        </div>
      </S.WrapperSchedulingActions>
    </>
  )
}

export default FormSteps
